import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

import { ref, watch } from "vue";

// PC端路由
const routesPc =  [
    {
       path:'/',redirect:'/reg-ko'
    },
  {
    path: '/reg-ko',
    name: 'pcdmcstorekr',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/pcindexkr.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp',
    name: 'pcdmcstorejp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/pcindexjp.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/probabilityjp',
    name: 'probabilityjp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/probabilityjp.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/probabilitykr',
    name: 'probabilitykr',
    component: () => import('@/views/probabilitykr.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/probabilitytw',
    name: 'probabilitytw',
    component: () => import('@/views/probabilitytw.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/probabilityen',
    name: 'probabilityen',
    component: () => import('@/views/probabilityen.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/reg-jp-tf1',
    name: 'mdmcstorejptf1',
    component: () => import('@/views/mindexjptf1.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf2',
    name: 'mdmcstorejptf2',
    component: () => import('@/views/mindexjptf2.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf3',
    name: 'mdmcstorejptf3',
    component: () => import('@/views/mindexjptf3.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf4',
    name: 'mdmcstorejptf4',
    component: () => import('@/views/mindexjptf4.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf5',
    name: 'mdmcstorejptf5',
    component: () => import('@/views/mindexjptf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf6',
    name: 'mdmcstorejptf6',
    component: () => import('@/views/mindexjptf6.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf1',
    name: 'mdmcstorekrtf1',
    component: () => import('@/views/mindexkrtf1.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf2',
    name: 'mdmcstorekrtf2',
    component: () => import('@/views/mindexkrtf2.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf3',
    name: 'mdmcstorekrtf3',
    component: () => import('@/views/mindexkrtf3.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf5',
    name: 'mdmcstorekrtf5',
    component: () => import('@/views/mindexkrtf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-en-tf5',
    name: 'mdmcstoreentf5',
    component: () => import('@/views/mindexentf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-en-tf6',
    name: 'mdmcstoreentf6',
    component: () => import('@/views/mindexentf6.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-tw-tf5',
    name: 'mdmcstoretwtf5',
    component: () => import('@/views/mindextwtf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-tw-tf6',
    name: 'mdmcstoretwtf6',
    component: () => import('@/views/mindextwtf6.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
]


// 移动端路由表
const routesMB = [
    {
        path:'/',redirect:'/reg-ko'
     },
  {
    path: '/reg-ko',
    name: 'mdmcstorekr',
    component: () => import('@/views/mindexkr.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp',
    name: 'mdmcstorejp',
    component: () => import('@/views/mindexjp.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/probabilityjp',
    name: 'probabilityjp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/mprobabilityjp.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/probabilitykr',
    name: 'mprobabilitykr',
    component: () => import('@/views/mprobabilitykr.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/probabilitytw',
    name: 'probabilitytw',
    component: () => import('@/views/mprobabilitytw.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/probabilitytw',
    name: 'mprobabilitytw',
    component: () => import('@/views/mprobabilitytw.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/probabilityen',
    name: 'mprobabilityen',
    component: () => import('@/views/mprobabilityen.vue'),
    meta: {
      title: '',
      showTab: false,
    },
  },
  {
    path: '/reg-jp-tf1',
    name: 'mdmcstorejptf1',
    component: () => import('@/views/mindexjptf1.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf2',
    name: 'mdmcstorejptf2',
    component: () => import('@/views/mindexjptf2.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf3',
    name: 'mdmcstorejptf3',
    component: () => import('@/views/mindexjptf3.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf4',
    name: 'mdmcstorejptf4',
    component: () => import('@/views/mindexjptf4.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf5',
    name: 'mdmcstorejptf5',
    component: () => import('@/views/mindexjptf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-jp-tf6',
    name: 'mdmcstorejptf6',
    component: () => import('@/views/mindexjptf6.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf1',
    name: 'mdmcstorekrtf1',
    component: () => import('@/views/mindexkrtf1.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf2',
    name: 'mdmcstorekrtf2',
    component: () => import('@/views/mindexkrtf2.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf3',
    name: 'mdmcstorekrtf3',
    component: () => import('@/views/mindexkrtf3.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-ko-tf5',
    name: 'mdmcstorekrtf5',
    component: () => import('@/views/mindexkrtf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-en-tf5',
    name: 'mdmcstoreentf5',
    component: () => import('@/views/mindexentf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
   {
    path: '/reg-new',
    name: 'mindex20260401',
    component: () => import('@/views/mindex20260401.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-en-tf6',
    name: 'mdmcstoreentf6',
    component: () => import('@/views/mindexentf6.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-tw-tf5',
    name: 'mdmcstoretwtf5',
    component: () => import('@/views/mindextwtf5.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
  {
    path: '/reg-tw-tf6',
    name: 'mdmcstoretwtf6',
    component: () => import('@/views/mindextwtf6.vue'),
    meta: {
        title: '',
        showTab: false,
      },
  },
]

// 声明变量用来接routers
var routes = [];
const screenWidth = ref()
// 获取页面宽度
screenWidth.value = document.body.clientWidth
if (screenWidth.value <= 1200) {
    console.log('is Mobile');

    routes = routesMB
} else {
    console.log('pc')
    routes = routesPc
}
window.onresize = () => {
    screenWidth.value = document.body.clientWidth;
};
// 监听页面宽度
watch(screenWidth, (newVal, oldVal) => {
    let timer = setTimeout(() => {
        if (newVal <= 1200) {
            // 小于758就是移动端 就把移动端路由表赋给routes
            console.log('is Mobile');
            routes = routesMB
            window.location.reload()
        } else {
            console.log('pc')
            // 大于就是pc端，把pc端路由表赋给routes
            routes = routesPc
            window.location.reload()
        }
        // 重绘页面
    }, 500)
    return () => {
        // 清除定时器
        clearTimeout(timer)
    }
}, {
    // 深度清除
    deep: true,
})
 
 
 
const router = createRouter({
    history: createWebHashHistory(),
    routes,
   
})


router.beforeEach((to, from, next) => {
    document.title = (to?.meta?.title) || document.title;
    next();
  })
  // router.afterEach((to, from) => {
  //   // 确保百度统计对象存在
  //   if (window._hmt) {
  //     // 将目标路由的路径推送给百度统计
  //     window._hmt.push(['_trackPageview', to.fullPath]);
  //   }
  // });
  

export default router
